import { streamingApi } from "./base.api";
import { JobRunInformation } from "types/JobRunInformation";

const BASE_PATH = "/job-moderator";

export const jobModeratorApi = streamingApi.injectEndpoints({
    endpoints: (build) => ({
        getRuns: build.query<JobRunInformation[], undefined>({
            query: () => `${BASE_PATH}/Jobs/LatestRuns`,
        }),
    }),
    overrideExisting: true,
});

export const { useGetRunsQuery } = jobModeratorApi;
